/**
 * How an organisation's supervision sessions are scheduled.
 *
 * `DEFAULT` — the platform's own schedule, no configuration needed.
 * `DYNAMIC` — scheduled per-organisation, set up by a CareBrain admin.
 *
 * An account-level setting (edited from ManageLimitsModal's Supervision
 * dropdown), not a usage limit — it does not meter or reset monthly, so it is
 * not part of `USAGE_METRIC`/`usageLimits.js`.
 */

export const SUPERVISION_MODE = {
  DEFAULT: 'DEFAULT',
  DYNAMIC: 'DYNAMIC',
}

export const SUPERVISION_MODE_LABEL = {
  [SUPERVISION_MODE.DEFAULT]: 'Default',
  [SUPERVISION_MODE.DYNAMIC]: 'Dynamic',
}

/** In display order, for the dropdown. */
export const SUPERVISION_MODE_OPTIONS = [SUPERVISION_MODE.DEFAULT, SUPERVISION_MODE.DYNAMIC]

/** One sentence explaining each mode, shown on the Usage limit tracking card. */
export const SUPERVISION_MODE_DESCRIPTION = {
  [SUPERVISION_MODE.DEFAULT]:
    'Our best practice quarterly supervision template. Simplest option — no configuration needed.',
  [SUPERVISION_MODE.DYNAMIC]:
    'In addition to our best practice template, build your own custom supervisions to suit your requirements',
}
